import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { ArrowLeft } from "lucide-react";
import ProductForm from "../ProductForm/ProductForm";
import { createProductStoreProductAction } from "../../slices/productStoreProductsSlice";
import { CreateProductStoreProductRequest } from "../../api/createProductStoreProduct/types";
import { useToast } from "@/components/ui/use-toast";

const ProductCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (data: CreateProductStoreProductRequest) => {
    setIsLoading(true);
    try {
      await dispatch(createProductStoreProductAction(data));
      toast({
        title: "Success",
        description: "Product created successfully",
        variant: "default",
      });
      navigate("/lead-generation/product-store/products");
    } catch {
      // Error handled by slice and global interceptor
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="p-6 max-w-3xl mx-auto">
      <Link
        className="inline-flex items-center gap-1 text-sm text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white mb-6 transition-colors"
        to="/lead-generation/product-store/products"
      >
        <ArrowLeft className="h-4 w-4" />
        Back to Products
      </Link>

      <div className="bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-lg p-6">
        <div className="mb-6">
          <h1 className="text-lg font-normal text-gray-900 dark:text-white">
            Create New Product
          </h1>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
            Fill out the details below to create a new product for the
            storefront.
          </p>
        </div>

        <ProductForm isLoading={isLoading} onSubmit={handleSubmit} />
      </div>
    </div>
  );
};

export default ProductCreatePage;
